export const ContactForm = {
  structure: {
    status: true,
    zones: [],
  },
  errors: {},
  blocks: [
    {
      col: [12],
      card: [
        {
          col: [6, 12, 3],
          name: 'name',
          label: 'Nombre',
        },
        {
          col: [6, 12, 3],
          type: 'email',
          name: 'email',
          label: 'E-mail',
        },
        {
          col: [6, 12, 3],
          name: 'phone',
          label: 'Teléfono',
        },
        {
          col: [6, 12, 3],
          name: 'address',
          label: 'Dirección',
        },
        {
          col: [2, 6, 2],
          name: 'DNI',
          label: 'Estado',
          endPoint: 'enumeration',
          type: 'select',
          isEnum: true,
        },
        {
          col: [2, 6, 2],
          name: 'status',
          label: 'Estado',
          endPoint: 'enumeration',
          type: 'select',
          isEnum: true,
        },
      ],
    },
  ],
};
